import { FACILITY_SUBTYPE } from "../../constants/facilityTypes";

/**
 * Derive facilitySubtypes array from enrollment facilityType form value.
 * Returns null for hospital/ED path (no new location doc with subtypes).
 *
 * @param {string | null | undefined} facilityType
 * @returns {string[] | null}
 */
export function deriveFacilitySubtypes(facilityType) {
  if (facilityType === "urgent-care") {
    return [FACILITY_SUBTYPE.CLINIC, FACILITY_SUBTYPE.URGENT_CARE];
  }
  if (facilityType === "clinic-only") {
    return [FACILITY_SUBTYPE.CLINIC];
  }
  return null;
}

/** @param {string | null | undefined} facilityType */
export function isClinicEnrollmentType(facilityType) {
  return facilityType === "urgent-care" || facilityType === "clinic-only";
}
